import { prevArrow, nextArrow } from "@/global/slick-options";

jQuery('.icons-slider .container-grid').slick({
    slidesToShow: 5,
    centerMode: true,
    centerPadding: '50px',
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    rows: 0,
    prevArrow,
    nextArrow,
    responsive: [
        {
        breakpoint: 1200,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
        }
        },
        {
        breakpoint: 768,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
        }
        },
        {
        breakpoint: 639,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
        }
        }
    ]
});
